import { SVGProps } from "react";

export default function AutomationFlowIcon(props: SVGProps<SVGSVGElement>) {
  const { width = 16, height = 16, stroke = "#545454", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M4 10V9.33333C4 8.97971 4.14048 8.64057 4.39052 8.39052C4.64057 8.14048 4.97971 8 5.33333 8H10.6667C11.0203 8 11.3594 8.14048 11.6095 8.39052C11.8595 8.64057 12 8.97971 12 9.33333V10M8 6V8M2 11.3333C2 10.9797 2.14048 10.6406 2.39052 10.3905C2.64057 10.1405 2.97971 10 3.33333 10H4.66667C5.02029 10 5.35943 10.1405 5.60948 10.3905C5.85952 10.6406 6 10.9797 6 11.3333V12.6667C6 13.0203 5.85952 13.3594 5.60948 13.6095C5.35943 13.8595 5.02029 14 4.66667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V11.3333ZM10 11.3333C10 10.9797 10.1405 10.6406 10.3905 10.3905C10.6406 10.1405 10.9797 10 11.3333 10H12.6667C13.0203 10 13.3594 10.1405 13.6095 10.3905C13.8595 10.6406 14 10.9797 14 11.3333V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H11.3333C10.9797 14 10.6406 13.8595 10.3905 13.6095C10.1405 13.3594 10 13.0203 10 12.6667V11.3333ZM6 3.33333C6 2.97971 6.14048 2.64057 6.39052 2.39052C6.64057 2.14048 6.97971 2 7.33333 2H8.66667C9.02029 2 9.35943 2.14048 9.60948 2.39052C9.85952 2.64057 10 2.97971 10 3.33333V4.66667C10 5.02029 9.85952 5.35943 9.60948 5.60948C9.35943 5.85952 9.02029 6 8.66667 6H7.33333C6.97971 6 6.64057 5.85952 6.39052 5.60948C6.14048 5.35943 6 5.02029 6 4.66667V3.33333Z"
        stroke={stroke}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
